/**
 * Call Centre Services Module
 * Exports all Call Centre Management services and the factory function.
 * Backend: CCMS.Api.CallCentreManagement (servicePath `callcentre`, gateway prefix `/callcentre/`).
 */
import { CallCentreLookupsService } from './CallCentreLookupsService';
import { CallCentreMeService } from './CallCentreMeService';
import { CallCentreAdminService } from './CallCentreAdminService';
export { CallCentreLookupsService, CallCentreMeService, CallCentreAdminService };
/**
 * Create all Call Centre Management services with shared configuration.
 */
export function createCallCentreServices(http, config) {
    return {
        callCentreLookups: new CallCentreLookupsService(http, config),
        callCentreMe: new CallCentreMeService(http, config),
        callCentreAdmin: new CallCentreAdminService(http, config),
    };
}
//# sourceMappingURL=index.js.map